<template>
    <div class="wrap">
        <div class="kv">
        </div>

        <div class="explain">
            <div class="explain-item">
                <div style="background: #0082C5"></div>
                <span>未评审</span>
            </div>
            <div class="explain-item">
                <div style="background: red"></div>
                <span>已评审</span>
            </div>
            <div class="space">
            </div>
            <div class="explain-item" @click="agree">
                <span class="agree"></span>
            </div>
        </div>

        <div class="content" id="content">
            <div id="item"  class="item-wrap" v-for="(item,index) in data" v-bind:key="index" @click="itemClick(item.caseId,item.scored)">
                    <div class="item">
                        <div v-if="item.caseId!=-1"  class="item-content">
                            <img src="../../assets/img/icon_yes.png" v-if="item.scored==0">
                            <img src="../../assets/img/icon_no.png" v-if="item.scored==1">
                            <span>病例{{index+1}}</span>
                        </div>
                        <div v-else class="">
                            <img class="plus" src="../../assets/img/bplus.png">
                        </div>
                    </div>
            </div>
        </div>

        <div class="btn-add" @click="itemClick(-1)" v-if="data.length>=1&&data[0].caseId!=-1">
            <div>
                <span>添加</span>
            </div>
        </div>

    </div>
</template>

<script>
    import {wxGetCase} from "@/assets/js/api";
    import {MessageBox} from 'mint-ui';

    export default {
        name: '', 
        data() {
            return {
                docId:this.$store.state.docId,
                data:[],
                background:"red"
            }
        },
        created(){
        },
        mounted(){
            this.getCase(this.docId)
            const that = this
            window.onresize = () => {
                return (() => {
                    that.heightWatching()
                })()
            }
        },
        methods: {
            agree(){
                // this.$toast("劳务协议")
                const message =
                    "<div style='text-align: left;font-weight: bold;color: #333'>说明1:</div>"+
                    "<div style='text-align: left;text-indent: 30px'><span>XXXXXXXXXXXXXXXXXXX</span></div>"+
                    "<div style='text-align: left;font-weight: bold;color: #333'>说明2:</div>"+
                    "<div style='text-align: left;text-indent: 30px'><span>&nbsp;XXXXXXXXXXXXXXXXXXX</span></div>"
                MessageBox.confirm(message,"征集说明",{
                    showCancelButton: false,
                    confirmButtonText:"确定",
                    // cancelButtonText:"取消"
                }).then(() => {
                });


            },
            async getCase(docId){
                const res = await wxGetCase({docId})
                this.data = res.data.data


                if(this.data.length==0){
                    let plusItem = {caseId:"-1"}
                    this.data.push(plusItem)
                }
                
                this.heightWatching();
                document.getElementById("content").style.gridTemplateRows = "repeat("+(parseInt(this.data.length/3))+",1fr)"//确认一下grid的行数（总数量/3）
            },
            heightWatching:function () {
                // let divWidth =  document.getElementById("item").offsetWidth;
                // document.getElementById("item").style.height = divWidth+"px"
            },
            itemClick(caseId,again){
                this.$router.push({path:"/wx_case",query:{caseId:caseId,again:again}})
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrap {
        width: 100%;
        max-width: 500px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #FFF;
        margin: 0 auto;
        overflow: auto;
    }

    .kv{
        width: 100%;
        padding: 56.25% 0 0;
        background: #FFF url("../../assets/img/wx_kv.jpg") no-repeat;
        background-size: 100% 100% ;
    }

    .content{
        /*display: grid;*/
        /*grid-template-columns: repeat(3,1fr);*/
        /*grid-gap: 10px;*/
        /*margin: 10px;*/

        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        /*justify-content: space-around;*/

    }

    .item-wrap{
        /*background: #0082c5;*/
        width: 33.3333%;
        height: 120px;
        .item{

            width: 80%;
            margin: 0 auto;
            border: #0082C5 1px solid;
            border-radius: 10px;

            span{
                margin-bottom: 5px;
                font-size: 15px;
            }

            .item-content{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin: 0 auto;
            }

        }
    }


    img{
        width: 80px;
        height: 80px;
    }

    .plus{
        width: 100px;
        height: 100px;
    }

    .explain {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin: 10px 3%;
        height: 30px;

        .explain-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 5px;

            div {
                width: 12px;
                height: 12px;
            }

            span {
                color: #0082C5;
            }
        }

        .space{
            flex: 1;
        }
    }
    .agree{
        width: 25px;
        height: 25px;
        background: #FFF url("../../assets/img/what.png") no-repeat;
        background-size: 100% 100%;
    }

    .btn-add{



        width: 80%;
        height: 30px;
        line-height: 30px;
        background: #0082C5;
        border-radius: 10px;
        color: #FFF;
        margin: 50px auto 0 auto;
        padding: 5px 0;
        font-size: 20px;
    }

</style>
